/* Telemetría temporal (2026-07-21) para diagnosticar el bug "pantalla en blanco
   al cambiar de página" que no se reproduce en pruebas automatizadas. Envía al
   backend (que lo saca por journalctl) para verlo aunque ocurra en un móvil real. */
export function reportClientError({ kind, message, stack }) {
  try {
    const body = JSON.stringify({
      kind, message, stack,
      url: location.href,
      ua: navigator.userAgent,
      noanim: sessionStorage.getItem('kanel-noanim') === '1',
      deviceMemory: navigator.deviceMemory ?? null,
      hardwareConcurrency: navigator.hardwareConcurrency ?? null,
      visibility: document.visibilityState,
      msSincePageLoad: Math.round(performance.now()),
    });
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/api/client-error', new Blob([body], { type: 'application/json' }));
    } else {
      fetch('/api/client-error', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
    }
  } catch {}
}
